import type { EChartsOption } from 'echarts';

import type { Metric, Trend } from './model';

const money = (value: number) =>
  new Intl.NumberFormat('en-AU', { style: 'currency', currency: 'AUD', maximumFractionDigits: 0 }).format(value);
export const metricText = (metric: Metric, value: number | null) =>
  value === null
    ? 'Unknown'
    : metric === 'Gross Sales' || metric === 'Margin'
      ? money(value)
      : value.toLocaleString('en-AU');

export function trendOption(
  trend: Trend,
  metric: Metric,
  selected: { from: string; to: string } | null,
  color: string,
): EChartsOption {
  const stacked = trend.series.length > 1;
  return {
    aria: { enabled: true },
    color: stacked ? undefined : [color],
    grid: { left: 64, right: 16, top: stacked ? 48 : 16, bottom: 56 },
    legend: stacked ? { type: 'scroll', top: 0 } : undefined,
    tooltip: {
      trigger: 'axis',
      axisPointer: { type: 'shadow' },
      valueFormatter: (value) => metricText(metric, typeof value === 'number' ? value : null),
    },
    dataZoom: [{ type: 'inside' }, { type: 'slider', height: 18, bottom: 8 }],
    xAxis: { type: 'category', data: trend.buckets },
    yAxis: { type: 'value', axisLabel: { formatter: (value: number) => metricText(metric, value) } },
    series: trend.series.map((series, index) => ({
      name: series.name,
      type: 'bar',
      stack: 'metric',
      data: series.values,
      markArea:
        index === 0 && selected
          ? { silent: true, itemStyle: { opacity: 0.12 }, data: [[{ xAxis: selected.from }, { xAxis: selected.to }]] }
          : undefined,
    })),
  };
}

export function barOption(labels: Array<string>, values: Array<number>, name: string, color: string): EChartsOption {
  return {
    aria: { enabled: true },
    color: [color],
    grid: { left: 48, right: 16, top: 16, bottom: 72 },
    tooltip: { trigger: 'axis', axisPointer: { type: 'shadow' } },
    xAxis: { type: 'category', data: labels, axisLabel: { rotate: labels.length > 8 ? 40 : 0 } },
    yAxis: { type: 'value', minInterval: 1 },
    series: [{ name, type: 'bar', data: values, label: { show: labels.length <= 12, position: 'top' } }],
  };
}
